import style from "./style.module.css";

interface TestDisplayNameProps {
  name: string;
  internalName?: string;
}

export function TestDisplayName({ name, internalName }: TestDisplayNameProps) {
  return (
    <>
      {name}
      {internalName && <span className={style.internalName}> ({internalName})</span>}
    </>
  );
}
